﻿import Routes from './routes';
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import muiTheme from './theme/muiTheme';
import config from './utils/config';

const App = () => {
  // Inicializa as configurações
  config.initialize();

  return (
    <ThemeProvider theme={muiTheme}>
      <Routes />
    </ThemeProvider>
  );
};

export default App;